import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { isSponsoredAccountAndDimension } from '../../../../../config/report-predicates/isSponsoredAccountAndDimension';
import { REPORT_PERMISSION } from '../../../../../config/reportPermissions';
import { ACCOUNT_MANAGER_GROUP } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import { ACCOUNT_MANAGER_GROUP_REPORT_ID } from './accountManagerGroupReportId';
import columnDefinitions from './columnDefinitions';
import footerColumnDefinitions from './footerColumnDefinitions';
import { defaultColumns, customColumns } from './reportPresets';

export const accountManagerGroupReportConfig = {
    id: ACCOUNT_MANAGER_GROUP_REPORT_ID,
    label: 'AM Group',
    permissions: [REPORT_PERMISSION.REP_BREAKDOWN_VIEW],
    visibilityCondition: isSponsoredAccountAndDimension,
    module: CAMPAIGNS_MODULE,
    endpoint: 'campaign-report-by-account-manager-group',
    rowIdField: ACCOUNT_MANAGER_GROUP.field,
    columnsDef: columnDefinitions,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    filters: [
        {
            id: FILTER_TYPE.SALES_PERSON,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
        {
            id: FILTER_TYPE.ACCOUNT_MANAGER,
            permissions: ['ADS_CONSOLE_ACCOUNTS_FILTERS', 'INTERNAL_FILTERS'],
        },
    ],
};

export default accountManagerGroupReportConfig;
